<template>
  <div class="sub-nav">
    <div class="sub-nav__inner">
      <div
          class="sub-nav__item"
          v-for="item in menulist"
          :key="item.id"
          :class="{ 'is-active': item.id == Index }"
          @click="Menupage(item.id)"
      >{{item.title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubMenu',
  data() {
    return {
      Index: 0,
      menulist: [
        {id: 0, title: '管理首页'},
        {id: 1, title: '我的网卡'},
        {id: 2, title: '我的终端'},
        {id: 3, title: '延期续费'},
        {id: 4, title: '个人中心'},
      ],
    }
  },
  created() {
    // 依据当前路由高亮对应菜单
    if (window.location.hash == '#/card-index') {
      this.Index = 1
    } else if (window.location.hash == '#/terminal-index') {
      this.Index = 2
    } else if (window.location.hash == '#/beoverdue-index') {
      this.Index = 3
    } else if (window.location.hash == '#/orderlist') {
      this.Index = 4
    }
  },
  methods: {
    Menupage(index) {
      if (index == 0) {
        this.$router.push("/index")
      } else if (index == 1) {
        this.$router.push("/card-index")
      } else if (index == 2) {
        this.$router.push("/terminal-index")
      } else if (index == 3) {
        this.$router.push("/beoverdue-index")
      } else if (index == 4) {
        this.$router.push("/orderlist")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 二级导航：白底页头下方用浅灰底，避免与页头糊成一片 */
.sub-nav {
  width: 100%;
  background: #f7f8fa;
  border-bottom: 1px solid #ebeef5;
}

.sub-nav__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  padding: 0 30px;
  box-sizing: border-box;
}

.sub-nav__item {
  position: relative;
  height: 52px;
  padding: 0 24px;
  line-height: 52px;
  font-size: 15px;
  color: #4e5969;
  cursor: pointer;
  transition: color 0.2s;

  /* 滑过时的进度条式下划线：从左向右展开 */
  &::before {
    content: '';
    position: absolute;
    left: 24px;
    right: 24px;
    bottom: 0;
    height: 2px;
    border-radius: 2px;
    background: #e53935;
    transform: scaleX(0);
    transform-origin: left center;
    transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  &:hover {
    color: #e53935;
  }

  &:hover::before {
    transform: scaleX(1);
  }

  &.is-active {
    color: #e53935;
    font-weight: 600;
  }

  &.is-active::after {
    content: '';
    position: absolute;
    left: 24px;
    right: 24px;
    bottom: 0;
    height: 2px;
    border-radius: 2px;
    background: #e53935;
  }

  /* 选中项已有常显横杠，滑过时不再重复展开动画 */
  &.is-active::before {
    transform: scaleX(0);
    transition: none;
  }
}

@media screen and (max-width: 768px) {
  .sub-nav__inner {
    padding: 0 8px;
  }

  .sub-nav__item {
    padding: 0 12px;
    font-size: 14px;

    &.is-active::after {
      left: 12px;
      right: 12px;
    }
  }
}
</style>
